import React from 'react'
import styled from 'styled-components'

import {Text} from '@/components/text'
import {Check} from '@/images/icons/check'
import type {FontColor} from '@/utils/is-valid-font-color'

type HighlightItemProps = {
    children: React.ReactNode
    $color?: FontColor
    $iconColor?: FontColor
    $iconSize?: number
}

export const HighlightItem = ({
    children,
    $color = 'dark',
    $iconColor = 'lightMuted',
    $iconSize = 24,
}: HighlightItemProps) => {
    return (
        <Item $iconColor={$iconColor}>
            <Check aria-hidden="true" width={$iconSize} height={$iconSize} />
            <Text as="span" $variant="paragraph-base" $color={$color}>
                {children}
            </Text>
        </Item>
    )
}

export const HighlightItemContainer = styled.ul`
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    gap: ${({theme}) => theme.spacings.s32};
    align-items: center;
    justify-content: center;
`

const Item = styled.li<{$iconColor: FontColor}>`
    display: flex;
    align-items: center;
    gap: ${({theme}) => theme.spacings.s12};

    svg path {
        fill: ${({theme, $iconColor}) => theme.colors.text[$iconColor]};
    }
`
